// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"fed2b966","787":"6711d82f"}[chunkId] + ".chunk.js";
};